// Source: app/scripts/controllers/auction-lot-registration.js
/**
 * Created by ristes on 20.4.15.
 */



Auction.controller('AuctionLotRegistrationController', [
  '$scope',
  '$filter',
  '$routeParams',
  '$sce',
  '$modal',
  'toaster',
  'Auction',
  'AuctionParticipationRequest',
  'Lot',
  function ($scope, $filter, $routeParams, $sce, $modal, toaster, Auction, AuctionParticipationRequest, Lot) {

    $scope.auctionId = $routeParams.auctionId;
    $scope.auction = Auction.get({
      id: $scope.auctionId
    });

    function load() {
      Auction.getProducts({
        id: $scope.auctionId
      }, function (data) {
        $scope.lots = data;
      });
    }

    load();

    $scope.modalSend = $modal({
      scope: $scope,
      template: 'forms/modals/send_lot_request.html',
      show: false
    });

    $scope.registerForAuction = function (lotDto) {
      $scope.requestEntity = {
        lot: {
          id: lotDto.lot.id
        },
        auction: lotDto.lot.auction
      };
        
      Lot.getLicensesTypes({
        id: lotDto.lot.id
      }, function (data) {
       lotDto.licenses = data;
      });
      $scope.req = {
        lotDto: lotDto
      };
      $scope.modalSend.show();
    };


    $scope.sendLotRequest = function () {
      AuctionParticipationRequest.sendRequest($scope.requestEntity, function () {
        delete $scope.requestEntity;
        $scope.modalSend.hide();
        load();
        toaster.pop('success', $filter('translate')('generic.success'),
          $filter('translate')("eauction.request_sent"));
      }, function () {
        load();
      });
    };

  }]);
